/* eslint-disable require-jsdoc */
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles';
import withBoundary from 'component/ErrorBoundary/withBoundary';
function GroupButton(props) {
  const { children, green, yellow, red, variant } = props;

  return (
    <Button
      onClick={props.onClick}
      sx={
        (green && styles.Button) ||
        (yellow && styles.yellowButton) ||
        (red && styles.redButton)
      }
      variant={variant}>
      {children}
    </Button>
  );
}
GroupButton.propTypes = {
  children: PropTypes.string,
  green: PropTypes.bool,
  onClick: PropTypes.func,
  red: PropTypes.bool,
  variant: PropTypes.string,
  yellow: PropTypes.bool
};
export default React.memo(withBoundary(GroupButton));
